export default __webpack_public_path__ + "static/media/it_1.ca040ecb.mp3";